import dompurify from 'dompurify'

angular
  .module 'shared'
  .directive 'domPurify', ->
    require: 'ngModel',
    link: (scope, element, attrs, ngModel) ->
      ngModel.$formatters.push (viewValue) ->
        dompurify.sanitize viewValue, ADD_ATTR: ['target', 'alt', 'data-asset-id']
